__turbopack_context__.v({
  "button": "LoginForm-module__HZfO4G__button",
  "form": "LoginForm-module__HZfO4G__form",
  "input": "LoginForm-module__HZfO4G__input",
});
